import type { ServicesTypes } from "@/redux/services/serviceTypes";

export const servicesReducer = {
  resetError: (state: ServicesTypes) => {
    state.error = null;
  },
  resetSuccess: (state: ServicesTypes) => {
    state.success = null;
  },
  resetIfscData: (state: ServicesTypes) => {
    state.ifscDetails = null;
  },
  resetBankAccountDetails: (state: ServicesTypes) => {
    state.bankAccountDetails = null;
  },
  resetGstDetails: (state: ServicesTypes) => {
    state.gstDetails = null;
  },
  resetPanVerifyData: (state: ServicesTypes) => {
    state.panVerifyDetails = null;
  },
  resetAuthorizedPanVerifyData: (state: ServicesTypes) => {
    state.authorizedPanVerifyDetails = null;
  },
  resetShippingAddressPanVerifyDetails: (state: ServicesTypes) => {
    state.shippingAddressPanVerifyDetails = null;
  },
  resetTanVerifyData: (state: ServicesTypes) => {
    state.tanVerifyDetails = null;
  },
  resetPanAadharLinkStatus: (state: ServicesTypes) => {
    state.panAadharLinkStatus = null;
  },
  resetServicesFetching: (state: ServicesTypes) => {
    state.fetching = false;
  },
};
